import { Checkbox } from 'primereact/checkbox';
import React from 'react';
import { Controller } from 'react-hook-form';

export const Disclaimer = ({ control, errors }) => {
    const currentDate = new Date();
    const formattedDate = currentDate.toLocaleDateString('es-ES', {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
    });
    return (
        <>
            {/* Disclaimer */}
            <div className="col-12 p-2">
                <Controller
                    name="checkboxField"
                    control={control}
                    defaultValue={false}
                    rules={{ required: 'Debes aceptar los términos y condiciones' }}
                    render={({ field }) => (
                        <Checkbox
                            inputId="checkboxField"
                            onChange={(e) => field.onChange(e.target.checked)}
                            checked={field.value}
                            invalid={errors["checkboxField"]}
                            style={{ color: "#29588c", borderColor: "#29588c" }}
                        />
                    )}
                />
                <label htmlFor="checkboxField" style={{ paddingLeft: ".5rem" }}>Acepto términos y condiciones</label>
            </div>

            <div className="grid">
                <div className="col Paragraph">
                    <span className='Disclaimer'>
                        Hoy {formattedDate}. Autorizo expresamente a CONDUCE CAPITAL SAPI DE CV., para llevar a cabo investigaciones sobre mi comportamiento crediticio en las sociedades de información crediticia (SIC) que estime conveniente.
                        Conozco la naturaleza y alcance de la información que se solicitará, del uso se le dará y que se podrán realizar consultas periódicas de mi historial crediticio. Consiento que esta autorización tenga una vigencia de 3 años contados a partir de hoy, y en su caso mientras mantengamos relación jurídica. Acepto que este documento queda bajo propiedad de CONDUCE CAPITAL SAPI DE CV. para efectos de control y cumplimiento del artículo 28 de la LRSIC.
                    </span>
                </div>
            </div>
        </>
    )
}